// src/components/artwork/ArtistQuoteChip.jsx
// Pastille discrète affichant la côte de l'artiste canonique lié à l'œuvre (artist_id).
// Lit la côte la plus récente dans artist_quotations (RLS = lecture authentifiée).
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { supabase } from "../../lib/supabaseClient";

const fmtUsd = (n) => {
  const a = Number(n);
  if (n == null || !Number.isFinite(a)) return "";
  if (a >= 1e9) return "$" + (a / 1e9).toFixed(1).replace(/\.0$/, "") + "Md";
  if (a >= 1e6) return "$" + (a / 1e6).toFixed(1).replace(/\.0$/, "") + "M";
  if (a >= 1e3) return "$" + Math.round(a / 1e3) + "k";
  return "$" + a;
};

export default function ArtistQuoteChip({ artistId }) {
  const { t } = useTranslation();
  const [quote, setQuote] = useState(undefined); // undefined = chargement, null = aucune

  useEffect(() => {
    let alive = true;
    if (!artistId) { setQuote(null); return; }
    (async () => {
      try {
        const { data } = await supabase
          .from("artist_quotations")
          .select("rank,best_result_usd,source_year")
          .eq("artist_id", artistId)
          .order("source_year", { ascending: false })
          .limit(1);
        if (alive) setQuote((data && data[0]) || null);
      } catch {
        if (alive) setQuote(null);
      }
    })();
    return () => { alive = false; };
  }, [artistId]);

  if (!artistId || quote === undefined) return null;

  const best = quote ? fmtUsd(quote.best_result_usd) : "";
  return (
    <div
      className="mt-1.5 inline-flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-full"
      style={{ background: "#faf6ec", color: "#a9843f", border: "1px solid #e5e0d8" }}
    >
      <span aria-hidden="true">◆</span>
      <span>{t("artworkEdit.artist.linked", { defaultValue: "Artiste référencé" })}</span>
      {quote?.rank ? <span>· Artprice #{quote.rank}</span> : null}
      {best ? <span>· {t("artworkEdit.artist.best", { defaultValue: "plus haut" })} {best}</span> : null}
    </div>
  );
}
